<div class="d-flex align-items-center" [ngClass]="class">
  <a
    class="pmd-avatar pmd-avatar-secondary me-3"
    [ngClass]="{ 'user-icon-container': !isRouterLinkDisabled }"
    *ngIf="user"
    [href]="mailContent"
    triggers="hover focus"
    [pmdPopover]="'Email this user'"
  >
    <img
      *ngIf="user.profileImage"
      class="profile-image"
      [src]="user.profileImage"
      [alt]="user.name + '\'s profile image'"
    />
    <span *ngIf="!user.profileImage">
      {{ user.shortName }}
    </span>
  </a>
  <div class="flex-grow-1" *ngIf="user">
    <a
      class="h6"
      [ngClass]="{ 'user-name': !isRouterLinkDisabled }"
      [routerLink]="isRouterLinkDisabled ? [] : ['/user', user.id]"
      *ngIf="user.name"
    >
      {{ user.name + (isMe && loggedinUser.id === user.id ? ' (me)' : '') }}
    </a>
    <p class="mb-0 card-subtitle" *ngIf="user.nickname">Nickname: {{ user.nickname }}</p>
    <p class="mb-0 card-subtitle" *ngIf="user.email">
      {{ user.email }}
    </p>
  </div>
</div>
